/**
 * Logs the user out of Cognito. When loginMethod is "nyc4d", also routes
 * through the NYC ID logout endpoint before returning to the app.
 * @param {string} [loginMethod] - The district's login method (e.g. "nyc4d")
 */
export function logout(loginMethod) {
  const APPCLIENT_ID = import.meta.env.VITE_APP_APPCLIENT_ID;
  const BASE_AUTH_URL = import.meta.env.VITE_APP_BASE_AUTH_URL;

  const effectiveHost =
    window.location.hostname === "localhost"
      ? "dev-mmp.hatsandladders.com"
      : window.location.host;

  const syepUri =
    effectiveHost === "app.hatsandladders.com"
      ? "https://www1.nyc.gov/account/idpLogout.htm?x-frames-allow-from=undefined%2F%2Fapp.hatsandladders.com"
      : `https://accounts-nonprd.nyc.gov/account/idpLogout.htm?x-frames-allow-from=undefined%2F%2F${effectiveHost}`;

  const logoutURI = loginMethod === "nyc4d" ? syepUri : window.location.origin;

  const logoutUrl = `${BASE_AUTH_URL}/logout?client_id=${APPCLIENT_ID}&logout_uri=${encodeURIComponent(logoutURI)}/`;

  localStorage.clear();
  sessionStorage.clear();
  window.location.href = logoutUrl;
}

/**
 * Redirects to the Cognito hosted-UI authorize endpoint to sign in. When
 * fromPath is provided it's round-tripped through the `state` param so the app
 * can return the user to their intended destination after authentication.
 * @param {string} [fromPath] - Path to return to after login
 */
export function redirectToLogin(fromPath) {
  const APPCLIENT_ID = import.meta.env.VITE_APP_APPCLIENT_ID;
  const BASE_AUTH_URL = import.meta.env.VITE_APP_BASE_AUTH_URL;
  const redirectUri = encodeURI(window.location.origin);
  const stateParam = fromPath ? `&state=${encodeURIComponent(fromPath)}` : "";
  // prompt=login makes Cognito show the sign-in form even when its own session
  // cookie is still live (a tab closed without logging out), so the next person
  // signs in as themselves rather than silently as the previous user. Only
  // honoured by managed login: the dev and staging domains report
  // ManagedLoginVersion 2, but that was set outside CDK (userpool-stack.js sets
  // no managedLoginVersion), so a domain still on the classic hosted UI ignores
  // it.
  window.location.href = `${BASE_AUTH_URL}/oauth2/authorize?client_id=${APPCLIENT_ID}&response_type=code&prompt=login&redirect_uri=${redirectUri}${stateParam}`;
}
